import { GoExternal } from '@clearkit/icons';
import { CKButton, CKCompanyLogo, CKLayoutHorizontal } from 'clearkit';
import { FC } from 'react';

import { GridList } from '~/components/unified/GridList';
import { Membership } from '~/generated/graphql';
import { useSwitchAccounts } from '~/hooks/account';
import history from '~/lib/history';

type MembershipListProps = {
  // TODO: Figure out type for memberships
  memberships: any;
};

export const MembershipList: FC<MembershipListProps> = ({ memberships }) => {
  const { mutateAsync: switchAccount } = useSwitchAccounts();

  const handleSwitchAccount = async (id: string) => {
    await switchAccount(id);
    history.push('/team');
  };

  return (
    <GridList
      className="text-sm grid gap-4"
      gridTemplateColumns="1fr 1fr 10rem"
    >
      <GridList.Header>
        <div>Team</div>
        <div>Role</div>
        <div></div>
      </GridList.Header>
      {memberships.map((membership: Membership) => {
        return (
          <GridList.Item key={membership.id}>
            <CKLayoutHorizontal
              className="font-medium"
              gap="0.75rem"
              justifyContent="start"
            >
              <CKCompanyLogo
                alt={membership.account.name ?? ''}
                domain={membership.account.domain ?? ''}
              />
              <span>{membership.account.name}</span>
            </CKLayoutHorizontal>
            <div className="pt-2">
              {membership.role === 'owner' ? 'Admin' : 'Member'}
            </div>
            <CKLayoutHorizontal justifyContent="end">
              <CKButton
                className="w-full"
                onClick={() => handleSwitchAccount(membership.account.id)}
                rightIcon={<GoExternal />}
                size="small"
                variant="simple"
              >
                Switch to team
              </CKButton>
            </CKLayoutHorizontal>
          </GridList.Item>
        );
      })}
    </GridList>
  );
};
